//todo: should probably be replaced with https://create-react-app.dev/docs/adding-custom-environment-variables/#adding-development-environment-variables-in-env
export const API_BASE_URL = "https://api.bcmserver.com";
export const clientId = 'a45fb89bbbbc45dda37969798afc9fca';
export const redirectUri = 'https://bcm-stream-d2d93.web.app/player/profile';
